export default {
  'analysis.alert.collectCount': {
    ko: '수집횟수',
    ja: '収集回数',
    en: 'Collection count',
    cn: '',
  },
  'analysis.alert.system': {
    ko: '시스템',
    ja: 'システム',
    en: 'System',
    cn: '',
  },
  'analysis.alert.config.kpi.threshold': {
    ko: 'KPI Threshold 설정',
    ja: 'KPI閾値設定',
    en: 'Config KPI Threshold',
    cn: '',
  },
  'analysis.alert.confirm.all': {
    ko: '모두확인',
    ja: '全てを確定',
    en: 'Confirm All',
    cn: '',
  },
  'analysis.alert.level.failback': {
    ko: '회복',
    ja: 'フェールバック',
    en: 'Failback',
    cn: '',
  },
  'analysis.alert.target': {
    ko: '대상',
    ja: '対象',
    en: 'Target',
    cn: '',
  },
  'analysis.alert.config.title': {
    ko: 'Alert 설정',
    ja: 'アラート設定',
    en: 'Alert Config',
    cn: '',
  },
  'analysis.alert.level.warning': {
    ko: '경고',
    ja: '警告',
    en: 'Warning',
    cn: '',
  },
  'analysis.alert.isActive': {
    ko: '활성화 여부',
    ja: '有効化の有無',
    en: 'Is active',
    cn: '',
  },
  'analysis.alert.isFailback': {
    ko: 'Failback 알림 여부',
    ja: 'フェイルバックの通知有無',
    en: 'Failback notification',
    cn: '',
  },
  'analysis.alert.contextAnalyzer': {
    ko: 'Context Analyzer',
    ja: 'コンテキストアナライザ',
    en: 'Context Analyzer',
    cn: '',
  },
  'analysis.alert.failover': {
    ko: '복구됨',
    ja: '回復済み',
    en: 'Restored',
    cn: '',
  },
  'analysis.alert.confirm': {
    ko: '확인',
    ja: 'OK',
    en: 'Confirm',
    cn: '',
  },
  'analysis.alert.level': {
    ko: '유형',
    ja: 'レベル',
    en: 'Level',
    cn: '',
  },
  'analysis.alert.level.critical': {
    ko: '심각',
    ja: '深刻',
    en: 'Critical',
    cn: '',
  },
  'analysis.alert.datetime': {
    ko: '일시',
    ja: '日時',
    en: 'DateTime',
    cn: '',
  },
  'analysis.alert.not.confirm': {
    ko: '미확인',
    ja: '未確認',
    en: 'Not Confirmed',
    cn: '',
  },
  'analysis.alert.level.info': {
    ko: '정보',
    ja: '情報',
    en: 'Info',
    cn: '',
  },
  'analysis.alert.isInrow': {
    ko: '연속 경고 여부',
    ja: '連続警告の有無',
    en: 'Alert in-a-row',
    cn: '',
  },
  'analysis.alert.description': {
    ko: '내용',
    ja: '内容',
    en: 'Description',
    cn: '',
  },
};
